var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 350,
    viewBox: "0 0 258 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.105 397.81C146.737 379.299 175.387 339.782 187.299 290.96C199.211 242.139 194.405 183.967 170.103 127.995C145.8 72.0239 106.578 28.7943 62.7745 4.16484C18.9703 -20.4649 -29.4634 -26.5131 -72.0963 -8.0022C-114.729 10.5087 -143.379 50.0259 -155.291 98.8474C-167.203 147.668 -162.397 205.841 -138.095 261.812C-113.792 317.784 -74.5698 361.013 -30.7662 385.643C13.038 410.273 61.4717 416.321 104.105 397.81Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2491 408.168C122.882 389.657 151.531 350.14 163.444 301.318C175.356 252.497 170.55 194.324 146.247 138.353C121.945 82.3818 82.7226 39.1522 38.919 14.5227C-4.8852 -10.107 -53.3189 -16.1552 -95.9518 2.35571C-138.585 20.8666 -167.234 60.3838 -179.146 109.205C-191.058 158.026 -186.252 216.199 -161.95 272.17C-137.648 328.142 -98.4253 371.371 -54.6217 396.001C-10.8175 420.63 37.6162 426.679 80.2491 408.168Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6907 419.265C97.3236 400.754 125.973 361.237 137.885 312.415C149.797 263.595 144.991 205.422 120.689 149.45C96.3866 93.479 57.1642 50.2494 13.3607 25.62C-30.4435 0.990208 -78.8773 -5.05797 -121.51 13.4529C-164.143 31.9639 -192.793 71.4811 -204.705 120.303C-216.617 169.123 -211.811 227.296 -187.508 283.268C-163.206 339.239 -123.984 382.468 -80.18 407.098C-36.3758 431.728 12.0579 437.776 54.6907 419.265Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0448 421.357C53.6776 402.846 82.3272 363.328 94.2393 314.507C106.151 265.686 101.345 207.513 77.043 151.542C52.7406 95.5706 13.5182 52.341 -30.2853 27.7116C-74.0895 3.08179 -122.523 -2.96639 -165.156 15.5445C-207.789 34.0554 -236.439 73.5726 -248.351 122.394C-260.263 171.215 -255.457 229.388 -231.154 285.359C-206.852 341.33 -167.63 384.56 -123.826 409.19C-80.0218 433.819 -31.5881 439.867 11.0448 421.357Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.79631 429.537C34.8366 411.026 63.4861 371.509 75.3983 322.688C87.3102 273.867 82.5043 215.694 58.2019 159.723C33.8995 103.751 -5.32282 60.5217 -49.1264 35.8923C-92.9306 11.2625 -141.364 5.21431 -183.997 23.7252C-226.63 42.2361 -255.28 81.7533 -267.192 130.575C-279.104 179.396 -274.298 237.569 -249.995 293.54C-225.693 349.511 -186.471 392.741 -142.667 417.37C-98.8629 442 -50.4292 448.048 -7.79631 429.537Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeRings);
export default __webpack_public_path__ + "static/media/large-rings.94e4807c0a8858b5617519acfdd55b79.svg";
export { ForwardRef as ReactComponent };